module.exports = __webpack_public_path__ + "img/s6.5532cde5.png";